import { ItemComponent } from '@seiue/ui'

import { BlockStateEnum } from 'packages/feature-utils/test-paper'
import { PaperBlock } from 'packages/sdks-next/growp'

import { BlockWrapper } from '../../BlockWrapper'

import { QuestionBlock } from './QuestionBlock'
import { QuestionBlockFooter } from './QuestionBlockFooter'

/**
 * 标题块
 *
 * @param param - Argument Object
 * @param param.blockData - 块数据
 * @param param.dragSource - 拖拽源
 * @constructor
 */
export const BlockQuestion: ItemComponent<{ blockData: PaperBlock }> = ({
  blockData,
  dragSource,
}) => (
  <BlockWrapper
    dragSource={dragSource}
    blockData={blockData}
    block={QuestionBlock}
    footers={[
      {
        visible: (f) => f.state === BlockStateEnum.Selected,
        render: QuestionBlockFooter,
      },
    ]}
  />
)
